"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCollection = exports.updateCollection = exports.addCollection = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

var _ = require(".");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var addCollection = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, id, title, slug, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, id = _ref.id, title = _ref.title, slug = _ref.slug;
            _context.next = 3;
            return (0, _.db)('createCollection', {
              siteID: siteID,
              id: id,
              title: title,
              slug: slug
            }, dispatch, config);

          case 3:
            result = _context.sent;

            if (result) {
              result = transformCollection(result);
            }

            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addCollection(_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

exports.addCollection = addCollection;

var updateCollection = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var siteID, id, title, slug, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteID = _ref2.siteID, id = _ref2.id, title = _ref2.title, slug = _ref2.slug;
            _context2.next = 3;
            return (0, _.db)('updateCollection', {
              id: id,
              siteID: siteID,
              title: title,
              slug: slug
            }, dispatch, config);

          case 3:
            result = _context2.sent;

            if (result) {
              result = transformCollection(result);
            }

            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateCollection(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

exports.updateCollection = updateCollection;

var deleteCollection = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, id = _ref3.id;
            _context3.next = 3;
            return (0, _.db)('deleteCollection', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context3.sent;

            if (result) {
              result = transformCollection(result);
            }

            return _context3.abrupt("return", result);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteCollection(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

exports.deleteCollection = deleteCollection;

var transformCollection = function transformCollection(collection) {
  var nextCollection = (0, _immer.default)(collection, function (draft) {
    if ((0, _lodash.get)(draft, "posts.items")) {
      draft.posts = draft.posts.items.reduce(function (ac, a) {
        return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a));
      }, {});
    }

    return draft;
  });
  return nextCollection;
};